import React, { useEffect, useRef, useState } from "react";
import { loginlogo } from "../../imagepath";
import { Link, useHistory } from "react-router-dom";
import ReactPasswordToggleIcon from "react-password-toggle-icon";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import PhoneInput from "react-phone-number-input";
import { useForm, useWatch } from "react-hook-form";
import {
  handleMobileOtpSubmit,
  handleApiEmailSentOtp,
  handlesubmitotpapi,
  registerapi,
  sendMoblieOTPapi,
} from "../../HttpRequest/beforelogin";
import { useAuth } from "../../../AuthContext";

const Registercopy = () => {
  const { login } = useAuth();
  const [EmailDisable, setEmailDisable] = useState(true);
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [isEmailOtpValid, setIsEmailOtpValid] = useState(false);
  const [isMobileOtpSent, setIsMobileOtpSent] = useState(false);
  const [isMobileOtpValid, setIsMobileOtpValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const { control, handleSubmit, formState, register, getValues } = useForm();
  const confirmPassword = useWatch({
    control,
    name: "confirmPassword",
  });
  const password = useWatch({
    control,
    name: "password",
  });

  useEffect(() => {
    formState.isValid && password === confirmPassword
      ? setEmailDisable(false)
      : setEmailDisable(true);
  }, [formState.isValid, confirmPassword, password]);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const orgNameVal = data.yourCollageName || data.orgName || "";
      const payload = {
        ...data,
        role: "super-admin",
        orgName: orgNameVal,
        yourCollageName: orgNameVal,
      };
      const registerResponse = await registerapi(payload);
      if (
        registerResponse.status === 200 ||
        registerResponse.status === 201
      ) {
        const resData = registerResponse.data || {};
        const newId = resData.id || resData.userId;
        if (newId) {
          // Clean up legacy localStorage keys
          localStorage.removeItem("id");
          localStorage.removeItem("userRole");
          localStorage.removeItem("role");
          localStorage.removeItem("orgId");
          localStorage.removeItem("orgName");
          localStorage.removeItem("authenticated");

          // Save exclusively to sessionStorage
          sessionStorage.setItem("id", newId);
          sessionStorage.setItem("userRole", "super-admin");
          sessionStorage.setItem("role", "super-admin");
          sessionStorage.setItem("authenticated", "true");
          if (resData.orgId) sessionStorage.setItem("orgId", resData.orgId);
          if (resData.orgName) sessionStorage.setItem("orgName", resData.orgName);

          if (login) login();
        }
        sessionStorage.setItem("user details", JSON.stringify(payload));
        history.push("/superadmin");
      } else {
        setIsMobileOtpValid(false);
      }
    } catch (error) {
      console.error("Error submitting registration:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEmailOtpSend = async (event) => {
    setLoading(true);
    event.preventDefault();
    const response = await handleApiEmailSentOtp(getValues("email"));
    if (response.status === 200) {
      setIsEmailSent(true);
    }
    setLoading(false);
  };

  /* SMS OTP request function commented out:
  const sendMoblieOTP = async (event) => {
    setLoading(true);
    event.preventDefault();
    const response = await sendMoblieOTPapi(getValues("phoneNumber"));
    response.status === 200
      ? setIsMobileOtpSent(true)
      : setIsMobileOtpSent(false);
    setLoading(false);
  };
  */

  const handlesubmitotp = async (event) => {
    setLoading(true);
    event.preventDefault();
    const response = await handlesubmitotpapi(
      getValues("email"),
      getValues("emailOtp")
    );
    console.log(response);
    if (response.status === 200) {
      setIsEmailOtpValid(true);
    }
    setLoading(false);
  };
  const eyeFunction1 = () => {
    var x = document.getElementById("password");
    let icon1 = document.getElementById("eyeicon2");
    if (x.type === "password") {
      x.type = "text";
      icon1.classList.toggle("fa-eye-slash");
    } else {
      x.type = "password";
      icon1.classList.toggle("fa-eye-slash");
    }
  };

  const eyeFunction2 = () => {
    var x = document.getElementById("confirmPassword");
    let icon2 = document.getElementById("eyeicon1");
    if (x.type === "password") {
      x.type = "text";
      icon2.classList.toggle("fa-eye-slash");
    } else {
      x.type = "password";
      icon2.classList.toggle("fa-eye-slash");
    }
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <div className="main-wrapper login-body">
          <div className="login-wrapper">
            <div className="container">
              <div className="loginbox">
                <div className="login-left">
                  <img className="img-fluid" src={loginlogo} alt="Logo" />
                </div>
                <div className="login-right">
                  <div className="login-right-wrap">
                    <h1>Sign Up</h1>
                    <p className="account-subtitle">
                      Enter details to create your account
                    </p>

                    {!isEmailOtpValid ? (
                      <>
                        {" "}
                        <div className="form-group">
                          <label>
                            First Name <span className="login-danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="firstName"
                            {...register("firstName", {
                              required: {
                                value: true,
                              },
                            })}
                          />
                          <span className="profile-views">
                            <i className="fas fa-user-circle" />
                          </span>
                        </div>
                        <div className="form-group">
                          <label>
                            Last Name <span className="login-danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="lastName"
                            {...register("lastName", {
                              required: {
                                value: true,
                              },
                            })}
                          />
                          <span className="profile-views">
                            <i className="fas fa-user-circle" />
                          </span>
                        </div>
                        <div className="form-group">
                          <label>
                            Email <span className="login-danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            type="email"
                            name="email"
                            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                            {...register("email", {
                              required: {
                                value: true,
                              },
                            })}
                          />
                          <span className="profile-views">
                            <i className="fas fa-envelope" />
                          </span>
                        </div>
                        <div className="form-group">
                          <label>
                            Create Password{" "}
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            className="form-control pass-input"
                            type="password"
                            name="password"
                            id="password"
                            {...register("password", {
                              required: {
                                value: true,
                              },
                            })}
                          />

                          <div onClick={eyeFunction1} class="eyeIcon">
                            <i
                              className="fas fa-eye"
                              aria-hidden="true"
                              id="eyeicon2"
                            ></i>
                          </div>
                        </div>
                        <div className="form-group">
                          <label>
                            confirm Password{" "}
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            className="form-control pass-input"
                            type="password"
                            id="confirmPassword"
                            name="confirmPassword"
                            {...register("confirmPassword", {
                              required: {
                                value: true,
                              },
                            })}
                          />
                          <div
                            onClick={eyeFunction2}
                            class="eyeIcon"
                            id="eyefunction2"
                          >
                            <i
                              className="fas fa-eye"
                              aria-hidden="true"
                              id="eyeicon1"
                            ></i>
                          </div>
                        </div>
                        {isEmailSent && (
                          <>
                            {" "}
                            <div className="form-group">
                              <label>
                                Enter OTP{" "}
                                <span className="login-danger">*</span>
                              </label>
                              <input
                                className="form-control"
                                type="number"
                                name="emailotp"
                                {...register("emailOtp", {
                                  required: {
                                    value: true,
                                  },
                                })}
                              />
                              <span className="profile-views">
                                <i className="fas fa-envelope" />
                              </span>
                            </div>
                          </>
                        )}
                        <div className=" dont-have">
                          Already Registered? <Link to="/">Login</Link>
                        </div>
                        <div className="form-group mb-0">
                          {isEmailSent ? (
                            <>
                              <button
                                className={`btn btn-primary btn-block ${
                                  loading ? "loading" : ""
                                }`}
                                type="submit"
                                disabled={loading}
                                onClick={handlesubmitotp}
                              >
                                {loading ? (
                                  <i className="fa fa-spinner fa-spin"></i>
                                ) : (
                                  "Submit OTP"
                                )}
                              </button>
                            </>
                          ) : (
                            <>
                              {" "}
                              <button
                                className={`btn btn-primary btn-block ${
                                  loading ? "loading" : ""
                                }`}
                                type="submit"
                                disabled={loading || EmailDisable}
                                onClick={handleEmailOtpSend}
                              >
                                {loading ? (
                                  <i className="fa fa-spinner fa-spin"></i>
                                ) : (
                                  "Send Email OTP"
                                )}
                              </button>
                            </>
                          )}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="phoneinput form-group">
                          {" "}
                          <label>
                            {" "}
                            Moblie Number{" "}
                            <span className="login-danger">*</span>{" "}
                          </label>
                          <PhoneInput
                            defaultCountry="IN"
                            name="phoneNumber"
                            className="phoneinputfiled form-control"
                            {...register("phoneNumber", {
                              required: {
                                value: true,
                              },
                            })}
                          />{" "}
                        </div>
                        <div className="phoneinput form-group">
                          {" "}
                          <label>
                            {" "}
                            Whatapp Number{" "}
                            <span className="login-danger">*</span>{" "}
                          </label>
                          <PhoneInput
                            defaultCountry="IN"
                            className="phoneinputfiled form-control"
                            name="whatsappNumber"
                            {...register("whatsappNumber", {
                              required: {
                                value: true,
                              },
                            })}
                          />{" "}
                        </div>

                        <div className="form-group">
                          <label>
                            DOB <span className="login-danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            type="date"
                            name="dateOfBirth"
                            {...register("dateOfBirth", {
                              required: {
                                value: true,
                              },
                            })}
                          />
                        </div>

                        <div className="form-group">
                          <label>
                            Organization / Institution Name{" "}
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="yourCollageName"
                            autoComplete="off"
                            placeholder="Enter Organization / Institution Name"
                            {...register("yourCollageName", {
                              required: {
                                value: true,
                              },
                            })}
                          />
                        </div>

                        <div className="form-group">
                          <label>
                            city <span className="login-danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="city"
                            autoComplete="off"
                            {...register("city", { required: { value: true } })}
                          />
                        </div>
                        {/* SMS OTP input field commented out
                        {isMobileOtpSent && (
                          <div className="form-group">
                            <label>
                              Moblie OTP <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control pass-confirm"
                              type="text"
                              name="mobileOtp"
                              {...register("mobileOtp", {
                                required: {
                                  value: true,
                                },
                              })}
                            />
                          </div>
                        )}
                        */}
                        <div className=" dont-have">
                          Already Registered? <Link to="/">Login</Link>
                        </div>
                        <div className="form-group mb-0">
                          {/* SMS OTP step bypassed - direct Register button */}
                          <button
                            className={`btn btn-primary btn-block ${
                              loading ? "loading" : ""
                            }`}
                            type="submit"
                            disabled={loading}
                          >
                            {loading ? (
                              <i className="fa fa-spinner fa-spin"></i>
                            ) : (
                              "Register"
                            )}
                          </button>
                        </div>
                      </>
                    )}
                    <> </>

                    <div className="login-or">
                      <span className="or-line" />
                      <span className="span-or">or</span>
                    </div>
                    <div className="social-login">
                      <Link to="#">
                        <i className="fab fa-google-plus-g" />
                      </Link>
                      <Link to="#">
                        <i className="fab fa-facebook-f" />
                      </Link>
                      <Link to="#">
                        <i className="fab fa-twitter" />
                      </Link>
                      <Link to="#">
                        <i className="fab fa-linkedin-in" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default Registercopy;
